// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c6dcddd9","977":"c4c4ec45"}[chunkId] + ".chunk.js";
};